





































import { Component, Vue, Model } from 'vue-property-decorator';
import { loginZhiNiao } from 'apiUtils/Login'
@Component({
  components: {
  },
})
export default class Login extends Vue {
  private usePassWord = false
  private userName = ''
  private password = ''
  private verCode = ''
  private get isCanLogin() {
    const userNameOk = this.userName.length === 11
    const verCodeOk = this.verCode.length === 6
    const passwordOk = this.password.length === 8
    if (this.usePassWord) {
      return userNameOk && passwordOk
    }
    return verCodeOk && verCodeOk
  }
  private getSecurityCodeBtnClass = {
    getSecurityCodeBtn: true,
    securityCodeBtnAbled: false,
  }
  private submitBtn = {
    submitBtn: true,
  }
  private onChangePhoneNumber(e: any) {
    this.userName = e.target.value.replace(/[^\d]/g, '').slice(0, 11);
    this.getSecurityCodeBtnClass.securityCodeBtnAbled = this.userName.length === 11
  }
  private onChangeVerCode(e: any) {
    this.verCode = e.target.value.slice(0, 6);
  }
  private deletePassWord(code: string) {
    this.password = ''
  }
  private deleteVerCode(code: string) {
    this.verCode = ''
  }
  private deleteUserName(code: string) {
    this.userName = ''
  }
  private changeLoginWay() {
    this.usePassWord = !this.usePassWord
  }
  private onSignin() {
    if (this.usePassWord) this.passWordLogin()
  }
  private passWordLogin() {
    const { password, userName } = this
    loginZhiNiao({
      strVer : '3.5.8',
      strOs : '33',
      channel: 'h5',
      v: '2',
      loginInfo : '',
      appId: 'com.pingan.zhiniao',
      ver : '3.5.8',
      umId: '',
      sid: '',
      nonGzip: 1,
      password,
      userName: '',
      mbNeedDowngrade: true
    })
  }
}
